module.exports = __webpack_public_path__ + "static/media/member_sample_basket_02.8a3338f0.jpg";